import './App.css';
import ProfileEditor from "./components/profile_editor/ProfileEditor";
import EditorUrlFetcherRequest from "./components/editor_url_fetcher/EditorUrlFetcherRequest";
import EditorUrlFetcher from "./components/editor_url_fetcher/EditorUrlFetcher";

import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router";


function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
            <Route path="/profile/:orgId/editor" element={<ProfileEditor />} />
            <Route path="/investor/:orgId/editor" element={<ProfileEditor />} />
            <Route path="/company/:orgId/editor" element={<ProfileEditor />} />
            <Route path="/url_fetcher" element={<EditorUrlFetcherRequest />} />
            <Route path="/url_fetcher/:requestId" element={<EditorUrlFetcher />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
